import { StyleSheet } from 'aphrodite'

import selector from './selector'
import daily from './daily'
import graph from './graph'
import topgeo from './topgeo'
import cpm from './cpm'

export default {
  selector: StyleSheet.create(selector),
  daily: StyleSheet.create(daily),
  graph: StyleSheet.create(graph),
  topgeo: StyleSheet.create(topgeo),
  cpm: StyleSheet.create(cpm)
}



// WEBPACK FOOTER //
// ./src/components/Statistics/style/ColorBlind/index.js